import React from "react";

import ProjectionGraph, {
  GraphDataPoint,
} from "@src/multiCustodian/components/ProjectionGraph/ProjectionGraph";

import Heading from "./Heading";

import styles from "./ProjectedReturnsGraph.module.css";

const data = [
  {
    date: "2025",
    range: [450_000, 450_000],
    value: 450_000,
  },
  {
    date: "2028",
    range: [450_000, 510_000],
    value: 500_000,
  },
  {
    date: "2030",
    range: [400_000, 550_000],
    value: 480_000,
  },
  {
    date: "2032",
    range: [450_000, 900_000],
    value: 700_000,
  },
  {
    date: "2035",
    range: [500_000, 1_400_000],
    value: 760_000,
  },
  {
    date: "2038",
    range: [600_000, 1_620_000],
    value: 1_240_000,
  },
  {
    date: "2040",
    range: [560_000, 1_750_000],
    value: 1_220_000,
  },
] as GraphDataPoint[];

const ProjectedReturnsGraph: React.FC = () => {
  return (
    <div className={styles.container}>
      <Heading />

      <div className={styles.graph}>
        <ProjectionGraph graphHeight={184} xAxisTickCount={2} data={data} />
      </div>
    </div>
  );
};

export default ProjectedReturnsGraph;
